import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

/**
 * Generic controller for multiple-step forms, whose fields are validated with HTML validations
 * All the steps of the form are loaded in the DOM by default, and toggled dynamically when clicking the next / previous button
 * We store the data of each step in localStorage (the localStorage item name should vary depending on the context, and is passed via a dedicated data attribute)
 */
export default class extends Controller {
  static targets = ["form", "submitLoader"];
  static outlets = ["sliding-content-workflow"];

  initialize() {
    this._groupSectionFields();

    this.formTarget.addEventListener("multiStepForm:inputAdded", () => {
      this._groupSectionFields();
    });

    this.localStorageItemName = this.element.dataset.localStorageItem;
    if (!this.localStorageItemName) {
      return;
    }

    if (localStorage.getItem(this.localStorageItemName)) {
      this._restoreFormState();
    } else {
      this.resetForm();
    }
  }

  nextStep() {
    $(this.formTarget)
      .parsley()
      .whenValidate({ group: "group-" + this.slidingContentWorkflowOutlet.currentSectionValue })
      .done(() => {
        this._saveFormState();
        this.slidingContentWorkflowOutlet.nextSection();
      });
  }

  previousStep() {
    this.slidingContentWorkflowOutlet.previousSection();
  }

  onSubmit() {
    if ($(this.formTarget).parsley().isValid()) {
      this._saveFormState();
      if (this.hasSubmitLoaderTarget) {
        this.formTarget.classList.add("hidden");
        this.submitLoaderTarget.classList.remove("hidden");
      }
    }
  }

  onSubmitCompleted() {
    if (this.hasSubmitLoaderTarget) {
      this.formTarget.classList.remove("hidden");
      this.submitLoaderTarget.classList.add("hidden");
    }
  }

  _groupSectionFields() {
    // Allows to validate fields of a given form-section together but independently of other section fields
    this.slidingContentWorkflowOutlet.sectionTargets.forEach((section, index) => {
      $(section).find(":input").attr("data-parsley-group", `group-${index}`);
    });
  }

  resetForm() {
    localStorage.setItem(this.localStorageItemName, JSON.stringify({}));
  }

  _restoreFormState() {
    const storedFormData = JSON.parse(localStorage.getItem(this.localStorageItemName));
    [...this.formTarget.elements]
      .filter((element) => element.name !== "authenticity_token")
      .forEach((element) => {
        if (storedFormData[element.name]) {
          element.value = storedFormData[element.name];
        }
      });
  }

  _saveFormState() {
    if (!this.localStorageItemName) {
      return;
    }

    const storedFormData = JSON.parse(localStorage.getItem(this.localStorageItemName));
    const currentFormData = new FormData(this.formTarget);
    [...currentFormData].forEach(([key, value]) => {
      storedFormData[key] = value;
    });
    localStorage.setItem(this.localStorageItemName, JSON.stringify(storedFormData));
  }
}
